import React from "react";

import { AccordionSummary } from "@mui/material";
import { compareDesc } from "date-fns";
import { ArrowDown2 as ArrowDownIcon } from "iconsax-react";
import { OrderToCustomerPortal, UserCustomerPortal } from "Models/customer.portal";
import { useTranslation } from "react-i18next";
import ReactTimeAgo from "react-time-ago";

import {
  Accordion,
  HistoryAvatar,
  HistoryContainer,
  HistoryCount,
  HistoryHeader,
  HistoryItem,
  HistoryItemMessage,
  HistoryItemTime,
  HistoryTitle,
} from "./styles";

interface ContactHistoryProps {
  order?: OrderToCustomerPortal;
}

export const ContactHistory = ({ order }: ContactHistoryProps) => {
  const { t: translate } = useTranslation();

  const getContact = (userId?: number) => {
    let contact: UserCustomerPortal | undefined;

    if (userId === order?.moveCoordinator?.id && order?.moveCoordinator) {
      contact = order?.moveCoordinator;
    }

    if (userId === order?.consultant?.id && order?.consultant) {
      contact = order?.consultant;
    }

    if (userId === order?.manager?.id && order?.manager) {
      contact = order?.manager;
    }

    return contact;
  };

  const getMessage = (userId?: number, contactRole?: string) => {
    const contact = getContact(userId);

    return `${translate("youContacted")} ${contact?.fullName || ""} ${
      contactRole ? `(${contactRole})` : ""
    }`;
  };

  const getInitials = (userId?: number) => {
    const contact = getContact(userId);

    if (contact?.fullName) {
      const [firstName, secondName] = contact.fullName.split(" ");

      return `${firstName[0] || ""}${secondName[0] || ""}`;
    }

    return "";
  };

  return (
    <Accordion elevation={0} disableGutters>
      <AccordionSummary expandIcon={<ArrowDownIcon size={16} />}>
        <HistoryHeader>
          <HistoryTitle>{translate("contactHistory")}</HistoryTitle>
          <HistoryCount>{order?.requestEscalations?.length}</HistoryCount>
        </HistoryHeader>
      </AccordionSummary>

      <HistoryContainer>
        {order?.requestEscalations
          ?.sort((a, b) => compareDesc(new Date(a.createdAt ?? ""), new Date(b.createdAt ?? "")))
          .map((escalation, index) => (
            <HistoryItem key={`${escalation?.id}-${index}`}>
              <HistoryAvatar>{getInitials(escalation?.userId)}</HistoryAvatar>
              <HistoryItemMessage>
                {getMessage(escalation?.userId, escalation?.toWhom)}
              </HistoryItemMessage>
              <HistoryItemTime>
                {!!escalation?.createdAt && <ReactTimeAgo date={new Date(escalation?.createdAt)} />}
              </HistoryItemTime>
            </HistoryItem>
          ))}
      </HistoryContainer>
    </Accordion>
  );
};
